// extracted by mini-css-extract-plugin
export var modal = "_g7-0";